import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Global Types
import { AppState } from 'services/types';
import { EntityName, EntitiesProps } from 'services/entities/types';

// Global Selectors
import { makeSelectEntityName } from 'services/entities/selectors';

type OwnProps = EntitiesProps;

interface ConnectedProps {
    name?: EntityName;
}

type Props = OwnProps & ConnectedProps;

export class EntityNameValueComponent extends React.PureComponent<Props> {
    render(): string | null {
        const { name } = this.props;

        if (!name) {
            return null;
        }

        return name;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    name: makeSelectEntityName()
});

export default connect(mapStateToProps)(EntityNameValueComponent);
